import b from 'b_';
import cx from 'classnames';
import React from 'react';

import { UI_KIT_HEADER_TYPOGRAPHY } from '../../constants';
import { H2 } from '../../header-text/header-text';

import './quiz__option.scss';

interface Props {
    option: string;
    mix?: string;
    color: string;
}

export const QuizOption = (props: Props) => {
    const { option, mix, color } = props;

    return (
        <div className={cx('quiz-teacher__answer-plate', mix)}>
            <div className={b('quiz-teacher__color-wrapper', { color })}>
                <H2 mix="quiz-teacher__answer-option" typography={UI_KIT_HEADER_TYPOGRAPHY.headlineLMedium}>
                    {option}
                </H2>
            </div>
        </div>
    );
};
